// extracted by css-extract-rspack-plugin
export default {"page":"lr9pEIJrDSw9OVIx","body":"F5L3_K3BMIAMOpaR","layout":"nl6XYkRoOakET0HQ","main":"j0HP4x9OWwDtBEAN","statusCard":"o_aQoRHRv94zaXRx"};